<template>
  <UiModal
    v-bind="$attrs"
    width="503px"
    align-center
    @update:model-value="onChangeValue"
  >
    <div
      class="min-h-[280px] px-6 pb-10 pt-[60px] text-center text-slate md:min-h-[360px] md:px-12 md:pb-14 md:pt-[105px]"
    >
      <div
        v-if="$slots.title"
        class="title mb-4 text-3xl uppercase leading-none"
      >
        <slot name="title"></slot>
      </div>

      <div v-if="$slots.body" class="mb-6 text-md leading-[1.8rem]">
        <slot name="body"></slot>
      </div>

      <div v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </UiModal>
</template>

<script setup lang="ts">
interface Emits {
  (e: 'update:modelValue', data: any): void;
}

const emit = defineEmits<Emits>();

const onChangeValue = (value: boolean) => {
  emit('update:modelValue', value);
};
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
